import { EnvironmentConfigurationError } from "../../packages/foundation/src/environment.js";
import targets from "./production-targets.json" with { type: "json" };

export function assertProductionWebEnvironment(
  app: "org-admin" | "platform-console",
  config: {
    environment: string;
    apiBaseUrl: string;
    firebase: { projectId: string; appId: string; authDomain: string; storageBucket: string };
    authProviders: { google: boolean; apple: boolean };
    appCheck: { siteKey: string };
    featureFlags: { environmentDiagnostics: boolean };
  },
): void {
  if (config.environment !== "production") return;
  const expected = targets[app];
  const checks: Array<[unknown, unknown, string]> = [
    [config.firebase.projectId, targets.projectId, "project"],
    [config.firebase.appId, expected.appId, "app ID"],
    [config.firebase.authDomain, expected.authDomain, "auth domain"],
    [config.firebase.storageBucket, targets.storageBucket, "Storage bucket"],
    [config.apiBaseUrl, targets.apiBaseUrl, "API destination"],
    [config.appCheck.siteKey, expected.siteKey, "App Check site key"],
    [config.authProviders.google, true, "Google provider"],
    [config.authProviders.apple, false, "Apple web provider"],
    [config.featureFlags.environmentDiagnostics, false, "diagnostics flag"],
  ];
  for (const [actual, required, field] of checks) {
    if (actual !== required) {
      throw new EnvironmentConfigurationError(
        `Production ${app} ${field} does not match the approved target.`,
      );
    }
  }
}
